export default __webpack_public_path__ + "static/dacs05-360d290a009ac7ea2788a3b720172108.jpg";